<div class="terms-of-use-dialog ups-dialog">
        <div class="dialog-header">
            <h2 mat-dialog-title>Parcel Pro Terms Of Use</h2>
            <mat-dialog-actions>
            </mat-dialog-actions>
            <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
        <mat-dialog-content>
            <upsc-terms-of-use></upsc-terms-of-use>
        </mat-dialog-content>
    </div>
    